// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button[data-v-5518263b]{margin-right:20px}input[data-v-5518263b]{border:1px solid #333}", ""]);
// Exports
module.exports = exports;
